const accountPauseOrShutdownReasons = [
    {
        index: 1,
        label: 'Didn’t generate enough sales'
    },
    {
        index: 2,
        label: 'Hard to use / too time-consuming'
    },
    {
        index: 3,
        label: 'Product(s) out of stock or discontinued'
    },
    {
        index: 4,
        label: 'Switching to another marketing channel'
    },
    {
        index: 5,
        label: 'No longer relevant for my business'
    },
    {
        index: 6,
        label: 'Technical issues / app not working as expected'
    },
    {
        index: 7,
        label: 'Other'
    }
];

// modal options based on type
export default {
    'campaign-paused': {
        title: 'Tell us why you’re pausing this campaign.',
        reasons: [
            {
                index: 1,
                label: 'Out of stock / inventory issue'
            },
            {
                index: 2,
                label: 'Low sales performance'
            },
            {
                index: 3,
                label: 'Updating product or campaign details'
            },
            {
                index: 4,
                label: 'Shifting business priorities'
            },
            {
                index: 5,
                label: 'Seasonal product (not relevant now)'
            },
            {
                index: 6,
                label: 'Temporary pause (will resume later)'
            },
            {
                index: 7,
                label: 'Other'
            }
        ],
        submitButtonText: 'Pause campaign',
        cancelButtonText: 'Cancel'
    },
    'account-paused': {
        title: 'Tell us why you’re pausing your account.',
        reasons: accountPauseOrShutdownReasons,
        submitButtonText: 'Submit feedback'
    },
    'account-shutdown': {
        title: 'Tell us why you’re shutting down your account.',
        reasons: accountPauseOrShutdownReasons,
        submitButtonText: 'Submit feedback'
    }
};
